import { forwardRef } from 'react';
import { BaseText } from './__internal__';
import { jsx as _jsx } from "react/jsx-runtime";
export const Text = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(BaseText, {
  ...props,
  ref: ref
}));
//# sourceMappingURL=Text.js.map